export function getTodaysDate() {
  const date = new Date();
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
